import { AfterViewInit, Directive, Input, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { AppConfigInterface, AppConfigService } from "../../services/app-config.service";

@Directive({
    selector  : "[hasRole]",
    standalone: true
})
export class HasRoleDirective implements OnInit, AfterViewInit {
    @Input("hasRole") allowedRoles: string = ""; // Roles permitidos

    private _userRole: string = '';
    
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private _appConfigService: AppConfigService,
    ) {
    }
    
    ngOnInit() {
        // Cuando la configuración de la aplicación cambie
        this._appConfigService.config
            .subscribe((config: AppConfigInterface) => {
                this._userRole = config.role ?? '';
                this.checkAccess();
            });
    }
    
    ngAfterViewInit() {
    }
    
    private checkAccess(): void {
        let hasAccess: boolean = true;
        
        if (typeof this.allowedRoles !== 'undefined') {
            const allowedRoles: string[] = this.allowedRoles.split("|");

            // Añadimos el rol de super-admin si no lo tiene
            if (!allowedRoles.includes("super-admin")) {
                allowedRoles.push("super-admin");
            }

            // `owner` es un admin de organización (más el cambio de organización
            // en organizaciones permitidas): todo lo visible para admin lo es
            // para owner. Centralizado aquí para no tocar cada `forRole` del
            // menú ni cada `*hasRole="'admin'"` de las plantillas.
            if (allowedRoles.includes("admin") && !allowedRoles.includes("owner")) {
                allowedRoles.push("owner");
            }
            
            // Verificar si el usuario tiene acceso
            hasAccess = allowedRoles.includes(this._userRole);
        }
        
        if (hasAccess) {
            // Si tiene acceso, mostrar el contenido
            if (this.viewContainer.length === 0) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
        } else {
            // Si no tiene acceso, ocultar el contenido
            this.viewContainer.clear();
        }
    }
}